import {ConfirmationDialog} from '@primer/react'
import {useCallback} from 'react'
import {useRelayEnvironment} from 'react-relay'

import {MESSAGES} from '../../constants/messages'
import {commitDeleteIssueMutation} from '../../mutations/delete-issue-mutation'
import styles from './IssueDeletionConfirmationDialog.module.css'

type IssueDeletionConfirmationDialogProps = {
  issueId: string
  onSuccessfulDeletion?: (issueId: string) => void
  afterDelete?: () => void
  onClose: () => void
}

export const IssueDeletionConfirmationDialog = ({
  issueId,
  onSuccessfulDeletion,
  afterDelete,
  onClose,
}: IssueDeletionConfirmationDialogProps) => {
  const environment = useRelayEnvironment()

  const onDialogClose = useCallback(
    (gesture: 'confirm' | 'cancel' | 'close-button' | 'escape') => {
      if (gesture === 'confirm') {
        commitDeleteIssueMutation({
          environment,
          input: {issueId},
          onCompleted: () => onSuccessfulDeletion?.(issueId),
        })
        afterDelete?.()
      }
      onClose()
    },
    [onClose, environment, issueId, onSuccessfulDeletion, afterDelete],
  )

  return (
    <ConfirmationDialog
      title={MESSAGES.deleteIssueConfirmationTitle}
      confirmButtonContent={MESSAGES.deleteIssueConfirmationButton}
      confirmButtonType="danger"
      onClose={onDialogClose}
    >
      <div className={styles.confirmationContent}>
        <ul className={styles.confirmationList}>
          {MESSAGES.deleteIssueConfirmationActionPoints.map(actionPoint => (
            <li key={actionPoint}>
              <span>{actionPoint}</span>
            </li>
          ))}
        </ul>
      </div>
    </ConfirmationDialog>
  )
}
